import { HTTP } from '@/http-common';
import { httpError } from '@/models/httpError';

const actions = {
  reset({ commit }) {},
  getCustomerAddresses({ rootState }) {
    return rootState.orders.address.addresses;
  },
  addAddresses({ rootState }, address) {
    rootState.orders.address.addresses.push(address);
  },
  getMarginSummary({dispatch}, companyNumber) {
    return new Promise((resolve, reject) => {
      if(companyNumber>0)
        var response = HTTP.post(`Utility/MarginReportSummaryDataAsync/${companyNumber}`);
      else 
        var response = HTTP.post(`Utility/MarginReportSummaryAsync/`)
      response
        .then(function(data) {
          let applications = data.data;
          // commit("setApplications", applications);
          resolve(applications);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "No record/s available: " + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
  getCostPerService({dispatch}) {
    return new Promise((resolve, reject) => {
        var response = HTTP.post(`Utility/GetCostPerServiceReport/`)
      response
        .then(function(data) {
          let applications = data.data;
          // commit("setApplications", applications);
          resolve(applications); 
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "No record/s available: " + err.message,
              httpStatus: 500
            })
          );
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  actions
};
